module.exports = __webpack_public_path__ + "img/jm.bb9712a0.svg";